// eslint-disable-next-line no-use-before-define
import React, { useLayoutEffect, useRef } from 'react';
import { ProfileMenuContainer, ProfileMenuDivider } from './style';
import { ProfileOption } from './components/profile-option';
import { LogoutIconSvg } from '../../../../../../assets/icons/logout';
import { GlobalIconSvg } from '../../../../../../assets/icons/global';
import { SettingsIconSvg } from '../../../../../../assets/icons/settings';
import { useTranslation } from 'react-i18next';
export const ProfileMenuComponent = ({ user, open, onClose, logout, openLangMenu, openAssistanceMenu, showLanguageMenu, }) => {
    const ref = useRef(null);
    const { t } = useTranslation('profileMenu');
    //Click outside component
    useLayoutEffect(() => {
        const checkIfClickedOutside = (e) => {
            if (ref.current &&
                ref.current !== e.target &&
                e.target.contains(ref.current)) {
                onClose();
            }
        };
        document.addEventListener('click', checkIfClickedOutside);
        return () => {
            document.removeEventListener('click', checkIfClickedOutside);
        };
    }, []);
    // Click outside in iframe
    useLayoutEffect(() => {
        const iframe = document.getElementById('root-app_iframe');
        if (iframe) {
            iframe.contentWindow.addEventListener('click', onClose);
        }
        return () => {
            iframe.contentWindow.removeEventListener('click', onClose);
        };
    }, [open]);
    if (!user) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(ProfileMenuContainer, { ref: ref, className: `${open ? 'open' : ''}` },
        React.createElement("div", { className: "profile-menu_user" },
            React.createElement("span", { className: "username" }, user.name),
            React.createElement("span", { className: "email" }, user.email)),
        React.createElement("div", null,
            !!showLanguageMenu && (React.createElement(ProfileOption, { title: t('profileMenu:changeLanguage'), svg: GlobalIconSvg, onClick: () => {
                    openLangMenu();
                    onClose();
                } })),
            React.createElement(ProfileOption, { title: t('profileMenu:assistance'), svg: SettingsIconSvg, onClick: () => {
                    openAssistanceMenu();
                    onClose();
                } })),
        React.createElement(ProfileMenuDivider, null),
        React.createElement(ProfileOption, { title: t('profileMenu:lougout'), type: "logout", onClick: () => {
                logout();
                onClose();
            }, svg: LogoutIconSvg })));
};
//# sourceMappingURL=component.js.map